/**
 * Draws a red notification dot on the current favicon (like Messenger).
 * Done in code via canvas — no designer asset needed.
 */

let originalFaviconHref: string | null = null

const BADGE_COLOR = "#e74c3c"
const SIZE = 32
const BADGE_RADIUS = 6
const BADGE_CX = SIZE - BADGE_RADIUS - 2
const BADGE_CY = BADGE_RADIUS + 2

function getFaviconLink(): HTMLLinkElement | null {
  if (typeof document === "undefined") return null
  return document.querySelector<HTMLLinkElement>('link[rel="icon"]')
}

export function restoreFavicon(): void {
  const link = getFaviconLink()
  if (link && originalFaviconHref) {
    link.href = originalFaviconHref
    originalFaviconHref = null
  }
}

export function setFaviconWithBadge(): void {
  const link = getFaviconLink()
  if (!link) return

  if (!originalFaviconHref) originalFaviconHref = link.href

  const img = new Image()
  img.crossOrigin = "anonymous"

  img.onload = () => {
    try {
      const canvas = document.createElement("canvas")
      canvas.width = SIZE
      canvas.height = SIZE
      const ctx = canvas.getContext("2d")
      if (!ctx) return

      ctx.drawImage(img, 0, 0, SIZE, SIZE)
      ctx.beginPath()
      ctx.arc(BADGE_CX, BADGE_CY, BADGE_RADIUS, 0, Math.PI * 2)
      ctx.fillStyle = BADGE_COLOR
      ctx.fill()
      ctx.strokeStyle = "rgba(255,255,255,0.9)"
      ctx.lineWidth = 1.5
      ctx.stroke()

      link.href = canvas.toDataURL("image/png")
    } catch {
      // ignore
    }
  }

  img.onerror = () => {
    try {
      const canvas = document.createElement("canvas")
      canvas.width = SIZE
      canvas.height = SIZE
      const ctx = canvas.getContext("2d")
      if (!ctx) return
      ctx.fillStyle = "#f0f0f0"
      ctx.fillRect(0, 0, SIZE, SIZE)
      ctx.beginPath()
      ctx.arc(BADGE_CX, BADGE_CY, BADGE_RADIUS, 0, Math.PI * 2)
      ctx.fillStyle = BADGE_COLOR
      ctx.fill()
      const link = getFaviconLink()
      if (link) link.href = canvas.toDataURL("image/png")
    } catch {
      // ignore
    }
  }

  img.src = originalFaviconHref || link.href
}
